// extracted by mini-css-extract-plugin
export default {"root":"app-portainer-components-PageHeader-LicenseExpirationPanel-module__root","message":"app-portainer-components-PageHeader-LicenseExpirationPanel-module__message"};